import { Subject } from 'rxjs';
import { staticCommercialProducer } from '../../staticCommercial';
import { mediaFilter } from '../extensions';
import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';

export class StaticCommercialPlugin implements PluginInterface {
  init(context: CastReceiverContext) {
    const loadStartSubject$ = new Subject<any>();
    mediaFilter.register(async media => {
      loadStartSubject$.next(media);
      return media;
    });
    staticCommercialProducer(loadStartSubject$, context.getPlayerManager());
  }
}
